import React, { useState, useEffect } from 'react';
import Toggle from '../../../Common/Toggle/Toggle';
import { FaEdit, FaTrash, FaPlus, FaSearch, FaSave, FaTimes } from 'react-icons/fa';
import '../Nucleos/Nucleos.css';

import API_BASE_URL from '../../../../config/api';

const OrgaosReferencia = () => {
  const [orgaosReferencia, setOrgaosReferencia] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [formData, setFormData] = useState({
    orgao_referencia: '',
    sigla: '',
    ativo: true
  });
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);

  const carregarOrgaos = async () => {
    setLoading(true);
    try {
      const response = await fetch(`${API_BASE_URL}/orgaos-referencia`);

      if (!response.ok) {
        throw new Error('Erro ao buscar órgão de referência');
      }

      const data = await response.json();

      const formatados = data.map((item) => ({
        id: item.id_orgao_referencia,
        orgao_referencia: item.nome_orgao_referencia,
        sigla: item.sigla,
        ativo: item.ativo
      }));

      setOrgaosReferencia(formatados);
    } catch (error) {
      console.error('Erro ao carregar órgão de referência:', error);
      alert(
        'Erro ao carregar órgão de referência. Verifique a conexão com o servidor.'
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    carregarOrgaos();
  }, []);

  const filteredOrgaosReferencia = orgaosReferencia.filter(orgao =>
    orgao && orgao.orgao_referencia && orgao.orgao_referencia.toLowerCase().includes((searchTerm || '').toLowerCase())
  );

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);

    try {
      const payload = {
        nome_orgao_referencia: formData.orgao_referencia,
        sigla: formData.sigla,
        ativo: formData.ativo
      };

      if (editingId) {
        const response = await fetch(
          `${API_BASE_URL}/orgaos-referencia/${editingId}`,
          {
            method: 'PUT',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(payload)
          }
        );

        if (!response.ok) {
          throw new Error('Erro ao atualizar órgão de referência');
        }

        const atualizado = await response.json();

        setOrgaosReferencia((prev) =>
          prev.map((orgao) =>
            orgao.id === editingId
              ? {
                  id: atualizado.id_orgao_referencia,
                  orgao_referencia: atualizado.nome_orgao_referencia,
                  sigla: atualizado.sigla,
                  ativo: atualizado.ativo
                }
              : orgao
          )
        );
      } else {
        const response = await fetch(`${API_BASE_URL}/orgaos-referencia`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(payload)
        });

        if (!response.ok) {
          throw new Error('Erro ao criar órgão de referência');
        }

        const criado = await response.json();

        setOrgaosReferencia((prev) => [
          ...prev,
          {
            id: criado.id_orgao_referencia,
            orgao_referencia: criado.nome_orgao_referencia,
            sigla: criado.sigla,
            ativo: criado.ativo
          }
        ]);
      }

      resetForm();
    } catch (error) {
      console.error('Erro ao salvar órgão de referência:', error);
      alert(
        'Erro ao salvar órgão de referência. Verifique os dados e tente novamente.'
      );
    } finally {
      setSaving(false);
    }
  };

  const handleEdit = (orgao) => {
    setFormData({
      orgao_referencia: orgao.orgao_referencia,
      sigla: orgao.sigla || '',
      ativo: orgao.ativo
    });
    setEditingId(orgao.id);
    setShowForm(true);
  };

  const handleDelete = async (id) => {
    if (
      !window.confirm(
        'Tem certeza que deseja excluir este órgão de referência?'
      )
    ) {
      return;
    }

    try {
      const response = await fetch(
        `${API_BASE_URL}/orgaos-referencia/${id}`,
        {
          method: 'DELETE'
        }
      );

      if (!response.ok && response.status !== 204) {
        throw new Error('Erro ao excluir órgão de referência');
      }

      setOrgaosReferencia((prev) => prev.filter((orgao) => orgao.id !== id));
    } catch (error) {
      console.error('Erro ao excluir órgão de referência:', error);
      alert('Erro ao excluir órgão de referência. Tente novamente.');
    }
  };

  const handleToggleStatus = async (id) => {
    const orgaoSelecionado = orgaosReferencia.find((o) => o.id === id);

    if (!orgaoSelecionado) {
      return;
    }

    const novoAtivo = !orgaoSelecionado.ativo;

    try {
      const response = await fetch(
        `${API_BASE_URL}/orgaos-referencia/${id}`,
        {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            nome_orgao_referencia: orgaoSelecionado.orgao_referencia,
            sigla: orgaoSelecionado.sigla,
            ativo: novoAtivo
          })
        }
      );

      if (!response.ok) {
        throw new Error('Erro ao atualizar status do órgão de referência');
      }

      const atualizado = await response.json();

      setOrgaosReferencia((prev) =>
        prev.map((orgao) =>
          orgao.id === id
            ? { ...orgao, ativo: atualizado.ativo }
            : orgao
        )
      );
    } catch (error) {
      console.error(
        'Erro ao atualizar status do órgão de referência:',
        error
      );
      alert(
        'Erro ao atualizar status do órgão de referência. Tente novamente.'
      );
    }
  };

  const resetForm = () => {
    setFormData({ orgao_referencia: '', sigla: '', ativo: true });
    setEditingId(null);
    setShowForm(false);
  };

  return (
    <div className="nucleos-container">
      <div className="tabela-header">
        <div className="header-content">
          <h1>Órgãos de Referência</h1>
        </div>
      </div>

      {showForm ? (
        <div className="form-container inline-form">
          <div className="form-header">
            <h2>{editingId ? 'Editar Órgão de Referência' : 'Cadastrar Órgão de Referência'}</h2>
          </div>
          
          <form onSubmit={handleSubmit} className="form-content">
            <div className="form-group">
              <label htmlFor="orgao_referencia">Órgão de Referência *</label>
              <input
                type="text"
                id="orgao_referencia"
                value={formData.orgao_referencia}
                onChange={(e) => setFormData({...formData, orgao_referencia: e.target.value})}
                required
                maxLength={100}
                placeholder="Digite o nome do órgão de referência"
              />
            </div>

            <div className="form-group">
              <label htmlFor="sigla">Sigla</label>
              <input
                type="text"
                id="sigla"
                value={formData.sigla}
                onChange={(e) => setFormData({ ...formData, sigla: e.target.value })}
                maxLength={20}
                placeholder="Ex: IBAMA"
              />
            </div>

            <div className="form-group">
              <Toggle
                id="ativo"
                label="Status:"
                checked={formData.ativo}
                onChange={(e) => setFormData({...formData, ativo: e.target.checked})}
              />
            </div>

            <div className="form-actions">
              <button type="button" className="btn-secondary" onClick={resetForm}>
                <FaTimes /> Cancelar
              </button>
              <button type="submit" className="btn-primary" disabled={saving}>
                <FaSave /> {saving ? 'Salvando...' : (editingId ? 'Atualizar' : 'Cadastrar')}
              </button>
            </div>
          </form>
        </div>
      ) : (
        <div className="table-container">
          <div className="table-controls">
            <div className="search-container">
              <FaSearch />
              <input
                type="text"
                placeholder="Pesquisar órgãos de referência..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>
            <div className="table-info">
              <span>
                {loading
                  ? 'Carregando órgãos de referência...'
                  : `${filteredOrgaosReferencia.length} registro(s) encontrado(s)`}
              </span>
            </div>
            <button 
              className="btn-primary" 
              onClick={() => setShowForm(true)}
            >
              <FaPlus /> Cadastrar Órgão
            </button>
          </div>

          <div className="table-wrapper">
            <table className="data-table nucleos-table">
              <thead>
                <tr>
                  <th className="col-id">ID</th>
                  <th className="col-sigla">Sigla</th>
                  <th className="col-nome">Órgão de Referência</th>
                  <th className="col-status">Status</th>
                  <th className="col-acoes">Ações</th>
                </tr>
              </thead>
              <tbody>
                {filteredOrgaosReferencia.map(orgao => (
                  <tr key={orgao.id}>
                    <td className="col-id">{orgao.id}</td>
                    <td className="col-sigla">
                      {orgao.sigla && (
                        <span className="sigla-badge">{orgao.sigla}</span>
                      )}
                    </td>
                    <td className="col-nome">{orgao.orgao_referencia}</td>
                    <td className="col-status">
                      <div className="status-toggle-wrapper">
                        <Toggle
                          checked={orgao.ativo}
                          onChange={() => handleToggleStatus(orgao.id)}
                          id={`toggle-${orgao.id}`}
                        />
                      </div>
                    </td>
                    <td className="col-acoes">
                      <div className="action-buttons">
                        <button 
                          className="btn-edit"
                          onClick={() => handleEdit(orgao)}
                          title="Editar"
                        >
                          <FaEdit />
                        </button>
                        <button 
                          className="btn-delete"
                          onClick={() => handleDelete(orgao.id)}
                          title="Excluir"
                        >
                          <FaTrash />
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            
            {filteredOrgaosReferencia.length === 0 && !loading && (
              <div className="empty-state">
                <div className="empty-state-icon">
                  <FaSearch size={32} />
                </div>
                <h3>Nenhum órgão de referência encontrado</h3>
                <p>Tente ajustar os filtros de pesquisa ou cadastre um novo órgão de referência.</p>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default OrgaosReferencia;
